import Request from "./index";

class api {
  //【前台】获取在线课程列表（分页）
  static getMoocPage(data) {
    return Request.get("/mooc/page", {
      params: data,
    });
  }

  //【前台】增加课程点击量
  static addClick(id) {
    return Request.put(`/mooc/clicks/${id}`);
  }

  //【前台】增加课程浏览记录
  static addHistory(id) {
    return Request.post(`/mooc/browsing_history/${id}`);
  }
}

export default api;
